export const getResultOffsets = (currentPage: number, numberPerPage: number) =>
  [(currentPage - 1) * numberPerPage, currentPage * numberPerPage] as const;
